const parseUrlToQueryParams = (searchParams: URLSearchParams) => {
    const queryParams: Record<string, any> = {
        search: searchParams.get("search") || "",
        limit: Number(searchParams.get("limit") || "20"),
        skip: Number(searchParams.get("skip") || "0"),
        // offset:
        //   Number(searchParams.get("page") || "0") *
        //   Number(searchParams.get("rows") || "25"),
        order: searchParams.get("order") || "",
        orderBy: searchParams.get("orderBy") || "",
    };

    // Get the filter parameter and parse it
    const filterParam = searchParams.get("filter");
    if (filterParam) {
        try {
            const filterStructure = JSON.parse(decodeURIComponent(filterParam));

            // Pass the filter structure directly to maintain the same format
            // { and: [{ column: { operator: value } }] }
            queryParams.filter = filterStructure;
        } catch (error) {
            console.error("Failed to parse filter parameter:", error);
        }
    }

    return queryParams;
};

export default parseUrlToQueryParams;
